import React from "react";

export default function GetDepartment({ departmentsList, depIndex }) {
  if (!departmentsList || departmentsList.length === 0) {
    return "מחלקה לא מוגדרת";
  }
  const searchType = departmentsList.find((dep) => dep.id == depIndex);
  return searchType ? searchType.title : "מחלקה לא מוגדרת";
}
